import { useMemo } from "react";
import { sanitizeHtml } from "./sanitizeHtml";

interface IProps {
    content: string;
}

export const Sanitize = (props: IProps) => {
    const sanitized = useMemo(
        () => sanitizeHtml(props.content),
        [props.content]
    );

    return <div dangerouslySetInnerHTML={{ __html: sanitized }} />;
};
